import cService from '@API/User/cService'
import axios from '@axios'

const { ddService } = cService(axios, {})
export default ddService
